import { navigate } from "../../../../service/navigation/Navigation";
import { appRoutes } from "../../../../routes/routes";
import ApiUrls from "../../../../service/api/ApiUrls";
import ApiService from "../../../../service/api/ApiService";
import SessionStorage from "../../../../service/storage/SessionStorage";
import StorageKeys from "../../../../const/StorageKeys";
import CacheStorage from "../../../../service/storage/CacheStorage";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import { SettingsAccountVerificationChangeEmailModel } from "../../../../model/settings/SettingsAccountVerificationChangeEmailModel";
import ShowToast from "../../../../widget/common/ui/Toast";

const SettingsPersonalSecurityProvider =
  new (class SettingsPersonalSecurityProvider {
    navigate = (url: string) => {
      if (UtilityHelper.isNotEmpty(url)) {
        navigate(url);
      }
    };

    submitPasswordAPI = async (newPassword: string): Promise<boolean> => {
      ApiUrls.init();

      const accountId: string =
        CacheStorage.getValue(StorageKeys.account_id) ?? "0";
      const url: string = `${ApiUrls.baseUrl}profile/update_password`;
      const body: any = {
        account_id: accountId,
        password: newPassword,
      };

      const response: any = await ApiService.postApi(url, body);
      if (response != null) {
        if (response["success"] === "1") {
          return true;
        } else {
          ShowToast.error(response["errorMessage"]);
        }
      }

      return false;
    };

    submitEmailAPI = async (
      newEmail: string
    ): Promise<SettingsAccountVerificationChangeEmailModel | null> => {
      ApiUrls.init();

      const accountId: string =
        CacheStorage.getValue(StorageKeys.account_id) ?? "0";
      const url: string = `${ApiUrls.baseUrl}profile/update_email`;
      const body: any = {
        account_id: accountId,
        email: newEmail,
      };

      const response: any = await ApiService.postApi(url, body);
      if (response != null) {
        if (response["success"] === "1") {
          const settingsAccountVerificationChangeEmailModel: SettingsAccountVerificationChangeEmailModel =
            response;

          if (settingsAccountVerificationChangeEmailModel != null) {
            SessionStorage.saveValue(
              StorageKeys.settings_verification_change_email_value,
              newEmail
            );

            SessionStorage.saveValue(
              StorageKeys.settings_verification_type,
              "email"
            );

            SessionStorage.saveValue(
              StorageKeys.settings_verification_detail,
              JSON.stringify(
                settingsAccountVerificationChangeEmailModel?.result
                  ?.email_change_result!
              )
            );

            navigate(appRoutes.routeNameSettingsAccountVerification);
          }

          return settingsAccountVerificationChangeEmailModel;
        } else {
          ShowToast.error(response["errorMessage"]);
        }
      }

      return null;
    };

    submitPhoneAPI = async ({
      phone_number,
      phone_code,
      phone_code_id,
    }: {
      phone_number: string;
      phone_code: string;
      phone_code_id: string;
    }): Promise<SettingsAccountVerificationChangeEmailModel | null> => {
      ApiUrls.init();

      const accountId: string =
        CacheStorage.getValue(StorageKeys.account_id) ?? "0";
      const url: string = `${ApiUrls.baseUrl}profile/update_mobile_number`;
      const body: any = {
        account_id: accountId,
        mobile_code_id: phone_code_id,
        mobile_code: phone_code.replaceAll("+", ""),
        mobile_no: phone_number.trim(),
      };

      console.log(body);

      const response: any = await ApiService.postApi(url, body);
      if (response != null) {
        if (response["success"] === "1") {
          const settingsAccountVerificationChangeEmailModel: SettingsAccountVerificationChangeEmailModel =
            response;

          if (settingsAccountVerificationChangeEmailModel != null) {
            SessionStorage.saveValue(
              StorageKeys.settings_verification_change_phone_value,
              JSON.stringify({
                phone_code: phone_code,
                phone_code_id: phone_code_id,
                phone_number: phone_number,
              })
            );

            SessionStorage.saveValue(
              StorageKeys.settings_verification_type,
              "phone"
            );

            SessionStorage.saveValue(
              StorageKeys.settings_verification_detail,
              JSON.stringify(
                settingsAccountVerificationChangeEmailModel?.result
                  ?.email_change_result!
              )
            );

            navigate(appRoutes.routeNameSettingsAccountVerification);
          }

          return settingsAccountVerificationChangeEmailModel;
        } else {
          ShowToast.error(response["errorMessage"]);
        }
      }

      return null;
    };
  })();

export default SettingsPersonalSecurityProvider;
